// base
import { History } from 'history';
import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { connectRouter } from 'connected-react-router';

// reducers
import { alarmReducer } from './alarm';
import { authReducer, type AuthState } from './auth';
import { companyReducer, type CompanyState } from './company';
import { uiReducer, uiSaga, type UiState } from './ui';
import { nationReducer, type NationState } from './nation';
import { systemReducer, type SystemState } from './system';
import { userReducer, type UserState } from './user';
import { workerReducer, type WorkerState } from './worker';
import { protectionReducer, type ProtectionState } from './protection/index.ts';
import { safetyReducer, type SafetyState } from './safety';
import { noticeReducer } from './notice';
import { projectReducer, type ProjectState } from './project';
import { qnaReducer } from './qna';
import { pmtReducer } from './pmt';
import { seclReducer } from './secl';
import { entryReducer, type EntryState } from './entry';
import {
  riskAssessmentReducer,
  type RiskAssessmentState,
  riskDatabaseReducer,
  type RiskDatabaseState
} from './riskAssessment';
import { chartDashboardReducer, type ChartDashboardState } from './dashboard';
import { commonReducer, type CommonState } from './common';
import { AlarmState } from './alarm/models/alarm.model';
import { environmentReducer, type EnvironmentState } from './environment';
import { excelReducer, type ExcelState } from './excel';
import { NoticeState } from './notice/models/notice.model';

export interface RootState {
  common: CommonState;
  auth: AuthState;
  ui: UiState;
  worker: WorkerState;
  user: UserState;
  safety: SafetyState;
  project: ProjectState;
  system: SystemState;
  company: CompanyState;
  entry: EntryState;
  notice: NoticeState;
  protection: ProtectionState;
  riskAssessment: RiskAssessmentState;
  chartDashboard: ChartDashboardState;
  riskDatabase: RiskDatabaseState;
  alarm: AlarmState;
  environment: EnvironmentState;
  excel: ExcelState;
  nation: NationState;
}

export function* saga(): Generator {
  yield all([fork(uiSaga)]);
}

const reducer = (history: History) =>
  combineReducers({
    auth: authReducer,
    nation: nationReducer,
    excel: excelReducer,
    system: systemReducer,
    company: companyReducer,
    user: userReducer,
    worker: workerReducer,
    router: connectRouter(history),
    ui: uiReducer,
    safety: safetyReducer,
    protection: protectionReducer,
    project: projectReducer,
    notice: noticeReducer,
    alarm: alarmReducer,
    qna: qnaReducer,
    pmt: pmtReducer,
    secl: seclReducer,
    entry: entryReducer,
    riskAssessment: riskAssessmentReducer,
    chartDashboard: chartDashboardReducer,
    riskDatabase: riskDatabaseReducer,
    common: commonReducer,
    environment: environmentReducer
  });

export default reducer;
